import './index.scss';
import Button from '../../Button/Button';
import { Eye, Send, X } from 'react-feather';
import { useTranslation } from 'react-i18next';
import ButtonEnum from '../../Button/ButtonEnum';
import '@styles/react/libs/react-select/_react-select.scss';
import '@styles/react/libs/tables/react-dataTable-component.scss';
import { SubscriptionManagement } from '../../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

interface MobileTableProps {
  data: any[];
  columns: any[];
  rowsPerPage?: number;
  pagination: any;
  header?: any;
  onSort?: (column: any, direction: any) => void;
  onRemoveItemCallback?: (value: any) => void;
  onEditItemCallback?: (value: any) => void;
  onDuplicateItemCallback?: (value: any) => void;
  onSendMailCallback?: (user: any) => void;
  onOpenUsageListCallback?: (order: any) => void;
  onCancelMembershipCallback?: (
    id: number,
    subscription: SubscriptionManagement
  ) => void;
}

const MobileTable = (props: MobileTableProps) => {
  const { t } = useTranslation();

  return (
    <div className="mobile-table">
      {props.data && Boolean(props.data.length) && (
        <div className="mobile-table-items">
          {props.data.map((item, index) => (
            <div
              className="mobile-table-item"
              key={item.id ? item.id : item.name + index}
            >
              {props.columns.map(
                (column, index) =>
                  !column.hideOnMobile && (
                    <div
                      key={index}
                      className="mobile-table-item-column"
                      onClick={(event: any) => {
                        if (event.target?.tagName !== 'INPUT') {
                          if (props.onEditItemCallback) {
                            props.onEditItemCallback(item.id);
                          }
                        }
                      }}
                    >
                      {column.mobileCell
                        ? column.mobileCell(item)
                        : column.cell(item)}
                    </div>
                  )
              )}
              <div className="mobile-cell-actions">
                {props.onRemoveItemCallback && (
                  <div
                    className="mobile-table-remove-button"
                    onClick={() =>
                      props.onRemoveItemCallback
                        ? props.onRemoveItemCallback(item.id)
                        : null
                    }
                  >
                    {t('MOBILE_TABLE_REMOVE_TEXT')}
                  </div>
                )}
                {props.onDuplicateItemCallback && (
                  <div
                    className="mobile-table-duplicate-button"
                    onClick={() =>
                      props.onDuplicateItemCallback
                        ? props.onDuplicateItemCallback(item.id)
                        : null
                    }
                  >
                    {t('MOBILE_TABLE_DUPLICATE_TEXT')}
                  </div>
                )}
                {props.onSendMailCallback &&
                  (item.userStatus === 'UNCONFIRMED' ||
                    item.userStatus === 'FORCE_CHANGE_PASSWORD') && (
                    <Button
                      text={t('RESEND_EMAIL')}
                      className="button-modal"
                      type={ButtonEnum.PRIMARY}
                      icon={<Send color="white" size={16} />}
                      onClick={() =>
                        props.onSendMailCallback
                          ? props.onSendMailCallback(item)
                          : null
                      }
                    />
                  )}
                {props.onOpenUsageListCallback && (
                  <div
                    className="mobile-table-duplicate-button"
                    onClick={() =>
                      props.onOpenUsageListCallback
                        ? props.onOpenUsageListCallback(item)
                        : null
                    }
                  >
                    <Eye size={18} className="edit-user-btn me-50" />{' '}
                  </div>
                )}
                {props.onCancelMembershipCallback && (
                  <Button
                    text={t('CANCEL_MEMBERSHIP_MOBILE_BUTTON_TEXT')}
                    className="button-modal"
                    type={ButtonEnum.DANGER}
                    icon={<X color="white" size={16} />}
                    onClick={() =>
                      props.onCancelMembershipCallback
                        ? props.onCancelMembershipCallback(
                            item.id,
                            item.subscription
                          )
                        : null
                    }
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      )}
      {!props.data.length && (
        <div className="mobile-table-empty-state">{t('NO_DATA_TABLE')}</div>
      )}
    </div>
  );
};

export default MobileTable;
